<template>
  <section class="slogan__container">
  <div class="container" data-animate-group>
    <div class="left-content" data-animate="slideUp">
      <p>{{ fields['Left text'] }}</p>
      <div class="icons">
        <a :href="item.link" class="icon-button" v-for="item in fields['Social']">
          <img :src="`${this.$store.state.base_directory}${item.image.replace(/^public\//, '')}`" alt="">
        </a>
      </div>
    </div>
    <div class="right-content" data-animate="slideUp">
      <p>
          {{ fields['Right text'] }}
      </p>
      <div class="footer">
        <span>{{ fields['Slogan and date'][0].slogan }}</span>
        <span>{{ fields['Slogan and date'][0].date }}</span>
      </div>
    </div>
  </div>
</section>
</template>

<script>
export default {
  name: "FieldServices",
  props: {
        fields: [Array,Object],
      },
};
</script>

<style scoped>
.container {
  display: flex;
  justify-content: space-between;
  flex-direction: row;
  gap: 20px;
  font-family: Arial, sans-serif;
}

.left-content {
  flex: 1;
  display: flex;
  text-align: left;
  flex-direction: column;
  justify-content: space-between;
  max-width: 25.5%;
}

.left-content p {
  color: rgb(5, 5, 5);
  font-size: 16px;
  font-weight: 400;
  line-height: 140%;
  letter-spacing: 0%;
  text-align: left;
}

.icons {
  display: flex;
  gap: 10px;
}

.icon-button {
  border: none;
  background: none;
  cursor: pointer;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background: rgb(222, 230, 234);
}

.icon-button img {
  width: 20px;
  height: 20px;
}

.right-content {
  flex: 2;
  max-width: 63%;
  text-align: left;
  max-width: 804px;
}

.right-content h2 {
  font-size: 24px;
  margin-bottom: 15px;
  color: #000;
}

.right-content p {
  /* Header/H2: 32px Medium */
  color: rgb(5, 5, 5);
  font-size: 32px;
  font-weight: 500;
  line-height: 140%;
  letter-spacing: 0%;
  text-align: left;
  padding-bottom: 69px;
  
}

.footer {
  display: flex;
  justify-content: space-between;
  color: rgb(5, 5, 5);
  font-family: Satoshi;
  font-size: 16px;
  font-weight: 500;
  line-height: 140%;
  letter-spacing: 0%;
  text-align: left;
  max-width: 409px;
}
@media (max-width: 1024px) {
  .right-content p{
    font-size: 24px;
  }
}
/* Адаптивность */
@media (max-width: 768px) {
  .container {
      flex-direction: column;
  }
  .right-content,.left-content{
      width: 100%;
      max-width: 100%;
  }
  .footer{
    max-width: unset;
  }
  .right-content p{
    padding-bottom: 20px;
  }
  .slogan__container{
    padding-top: 0px !important;
  }
  .left-content{
      order: 2;
  }
  .left-content p{
      padding-bottom: 24px;
      font-size: 14px;
  }
}
</style>
